<article class="sizeOfPrizeChart">
  <div class="header">
    <h2>Size of Prize</h2>
    <h3>
      {{ dataFilters.regionSelection.getName() }} - {{ dataFilters.year }}
    </h3>
    <mpro-tags style="margin: 15px 0px"></mpro-tags>
  </div>
  <div class="chart">
    <div class="graph-and-header">
      <mpro-loading *ngIf="isSOPloading"></mpro-loading>
      <h4>Chart type</h4>
      <div class="buttons">
        <button
          color="blue"
          hue="500"
          mproButtton="secondary"
          *ngFor="let b of constants.data.sizeOfPrizesorting"
          [ngClass]="b.id === activeChart ? 'active' : ''"
          (click)="handleClick(b.id)"
          [selected]="b.id === activeChart"
        >
          {{ b.text }}
        </button>
      </div>
      <div
        id="legend"
      >
        <ng-container *ngFor="let item of constants.legendItems">
          <div
          >
            <span [style.backgroundColor]="item.color"></span>
            {{ item.text }}
          </div>
        </ng-container>
      </div>
  
      <ng-container [ngSwitch]="activeChart">
        <mpro-treemap
          *ngSwitchCase="'treemap'"
          [countries]="tableData"
        ></mpro-treemap>
        <mpro-piechart
          *ngSwitchCase="'pie'"
          [countries]="tableData"
          [year]="currentYear"
          [isFreemium]="isFreemium"
        ></mpro-piechart>
        <mpro-scatter
          *ngSwitchCase="'scatter'"
          [countries]="tableData"
          [selectedItemsList]="selectedItemsList"
        ></mpro-scatter>
      </ng-container>
    </div>
    <div class="graph-table">
      <table>
        <thead>
          <tr>
            <th>
              <mpro-table-column
                header="Position"
                [property]="'index'"
                (sortChanged)="onSort($event)"
                [sortDir]="SortDirection.NONE"
              ></mpro-table-column>
            </th>
            <th>
              <mpro-table-column
                [header]="continentOrCountry"
                [property]="'continent'"
                (sortChanged)="onSort($event)"
                [sortDir]="SortDirection.NONE"
              ></mpro-table-column>
            </th>
            <th>
              <mpro-table-column
                [header]="'Total ' + dataFilters.spendingGroup.type.toLocaleLowerCase()"
                [property]="'spending_ppp'"
                (sortChanged)="onSort($event)"
                [sortDir]="SortDirection.NONE"
              ></mpro-table-column>
            </th>
          </tr>
        </thead>
        <tbody #tbody>
          <tr
            *ngFor="let c of tableData; let i = index"
            [id]="'region-comp-' + c.continentName"
          >
            <td>{{ c.position }}</td>
            <td>{{ isFreemium ? c.continentName : c.countryName }}</td>
            <td>${{ c.totalAmount.toLocaleString("en-EN") }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</article>
